import ApplicationAdapter from 'eflex/adapters/application';

export default class KineticOperationAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
